import { NAVIGATION_KEYS } from "../../src/components/Layout/NavBar/types"
import { TransactionType } from "../../src/domain/ethereum/Models/Transaction"

export default {
  navigation: {
    [NAVIGATION_KEYS.POAPS]: {
      title: "POAPs",
      description: "Visualiza tus POAPs y gestiona tu colección",
    },
    [NAVIGATION_KEYS.WALLET]: {
      title: "Cartera",
      description: "Visualiza tus posiciones de liquidez tanto en billetera como en contratos",
    },
    [NAVIGATION_KEYS.SETTINGS]: {
      title: "Ajustes",
      description: "Selecciona Idioma, Moneda y Modo claro / oscuro",
    },
  },
  back: "Volver",
  connect: "Conectar",
  connectWallet: "Conecta tu wallet",
  contractAdress: "Dirección del contrato",
  copy: "Copiar",
  copied: "Copiado",
  clean: "Limpiar",
  error: "Error",
  settings: {
    title: "Ajustes",
    languages: {
      es: "Español",
      en: "Inglés",
    },
    mode: {
      light: "Claro",
      dark: "Oscuro",
    },
  },
  settingsMenu: "Ajustes",
  settingsDescription: "Selecciona Idioma, Moneda y Modo claro / oscuro",
  docs: "Docs",
  docsDescription: "Accede a nuestro Whitepaper para comprender en profundidad el protocolo",
  wallet: "Cartera",
  walletDescription: "Visualiza tus posiciones de liquidez tanto en billetera como en contratos",
  walletMobileDescription: "Visualiza tus posiciones en todos los tokens del DEX",
  walletAdd: "Añadir a wallet",
  yourAccount: "Tu cuenta",
  myHumanWallet: "Mi HumanWallet",
  timeUnits: {
    second: "segundo",
    seconds: "segundos",
    minute: "minuto",
    minutes: "minutos",
    hour: "hora",
    hours: "horas",
    day: "día",
    days: "días",
    week: "semana",
    weeks: "semanas",
    month: "mes",
    months: "meses",
    year: "año",
    years: "años",
  },
  mint: "Mintear",
  type: "Tipo",
  new: "Nuevo",
  updateVersion: "Hay una actualización disponible, ¿Deseas actualizar?",
  other: "Otro",
  totalDistributed: "Total repartido",
  dailyDistributed: "Hoy se reparten:",
  transactions: {
    title: "Transacciones",
    noTransactions: "No hay transacciones",
    errorMessage: "No se ha podido completar la transacción. Revisa la dirección o el saldo de tokens disponibles.",
    seeTransaction: "Ver transacción",
    types: {
      [TransactionType.MINT_POAP]: "Mint POAP",
    },
    status: {
      PENDING: "Pendiente",
      SUCCESS: "Confirmada",
      REVERTED: "Revertida",
    },
  },
  signature: {
    title: "Firma",
    errorMessage: "No se ha podido firmar la transacción. Revisa la dirección o el saldo de tokens disponibles.",
    status: {
      PENDING: "Pendiente",
      SUCCESS: "Confirmada",
      REVERTED: "Revertida",
    },
  },
  viewContract: "Ver contrato",
  viewInExplorer: "Ver en el explorador",
  view: "Ver",
  disconnect: "Desconectar",
  address: "Dirección",
  network: "Red",
  sendToSupport: "Enviar a Soporte",
  footer: {
    documentation: "Documentación",
    brandKit: "Kit de Marca",
    legalDisclaimer: "Aviso Legal",
  },
}
